<template>
  <v-layout flex-fill column class="survey-type-01">
    <div class="subheader">
      최근 2주간 당신의 상태에 대한 문항입니다. <br>문항의 내용을 얼마나 자주 느꼈는지 응답해 주세요.
    </div>
    <div class="question-wrapper">
      <div class="question" v-html="question"></div>
    </div>
    <div class="answer">
      <RadioGroup :str="replyList" :replyNo="replyNoList" :answer="answer" @changed="changed"/>
    </div>
  </v-layout>
</template>

<script>
import store from '@/store'
import { mixinAuth } from '@/mixins'
import RadioGroup from '@/components/forms/RadioGroup'

export default {
  components: {
    RadioGroup
  },
  mixins:[mixinAuth],
  props: ["question", "surveyData", "travelApplStepCd", "memberStepApplCnt"],
  data: () => ({
    replyList: [],
    replyNoList: [],
    answer: 0
  }),
  watch: {
    question() {
      // question 문구 변경시 실행됨
      this.getTravelReplyList(this.surveyData.unitDtlQuesNo);
    }
  },
  created() {
    // SurveyType01 호출시 실행됨
    this.getTravelReplyList(this.surveyData.unitDtlQuesNo);
  },
  methods: {
    changed(newAnswer) {
      this.$emit('radioChanged', newAnswer, true)
    },
    async getTravelReplyList(unitDtlQuesNo) {  // 답변 리스트 호출
      console.log('Step 01 - getTravelReplyList Call');
      this.answer = 0;
      await store.dispatch('getTravelReplyList', this.$_payload('so', [{'travelApplNo': this.surveyData.travelApplNo}, {'unitDtlQuesNo': unitDtlQuesNo}]))
        .then(res => {
          console.log('Step 01 - getTravelReplyList : ', res);
          if (res.success) {
            this.replyList = res.data.map((item) => item.replyNm);
            this.replyNoList = res.data.map((item) => item.unitDtlReplyNo);
            this.getStepLoadData();
          } else {
            console.log(res.msg)
            this.replyList = ''
          }
        })
        .catch(error => {
          console.error(error)
          this.replyList = ''
        })
        .finally(() => {
        })
    },
    async getStepLoadData() { // 스텝별 저장 데이터를 가져옴.
      console.log('Step 01 - getStepLoadData Call');
      await store.dispatch('getStepLoadData', this.$_payload('so', [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitNo': this.surveyData.unitNo},
        {'unitDtlNo': this.surveyData.unitDtlNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'memberNo': this.userKey},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
        .then(res => {
          if (res.success) {
            if (res.data.reply == null) {
              this.answer = null;
            } else {
              this.answer = res.data.unitDtlReplyNo;
            }
            this.$emit('radioChanged', this.answer)
          } else {
            console.log(res.msg)
            this.answer = null;
          }
        })
        .catch(error => {
          console.error(error)
          this.answer = null;
        })
        .finally(() => {
        })
    },
  }
}

</script>
